import { Teaser as t } from '@xprog/prensa/types'
import { TeaserRelated } from './TeaserRelated'

export const TeaserVideoFeatMd: t.TeaserProps = {
  css: {
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3',
      width: 'auto'
    },
    padding: '$0',
    width: '100%',
    '@lg': {
      width: 'calc(50% - $4)',
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4',
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        },
      },
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.2px',
      fontWeight: 500,
      width: '100%',
      '@lg': {
        fontSize: '25px',
        fontWeight: 600,
        letterSpacing: '0.2px',
        lineHeight: '30px',
      }
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top']
    },
  },
  className: 'TeaserVideoFeatMd',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
}
